import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { IconDirective } from '../icon/icon.directive';

export type BannerType = 'warning' | 'error' | 'info' | 'neutral' | 'success';
export type BannerSize = 'small' | 'normal';

@Component({
  selector: 'tt-banner',
  standalone: true,
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, IconDirective],
  host: {
    '[class]': 'hostCls()',
  },
})
export class BannerComponent {
  public icon = input<string>();
  public message = input<string>('');
  public type = input<BannerType>('warning');
  public size = input<BannerSize>('normal');

  protected _icon = computed(() => {
    const icon = this.icon();
    if (icon) {
      return icon;
    }

    switch (this.type()) {
      case 'warning':
        return 'warning';
      case 'error':
        return 'error';
      case 'info':
        return 'info';
      case 'neutral':
        return 'neutral';
      default:
        return 'info';
    }
  });

  protected hostCls = computed<string>(() => {
    const sizeClass = this.size() !== 'normal' ? `tt-banner--${this.size()}` : '';
    return `tt-banner tt-banner--${this.type()} ${sizeClass}`;
  });
}
